import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { containerPaddingM } from 'common/styles/variables';
import { getGenericSubmissionErrorMessage } from 'common/entities/form/errorMessages';
import { getActiveSidebarTab, getOpenStylingSection } from '../../selectors';
import { getFormErrors } from '../../selectors/form';
import FormErrorMessage from './FormErrorMessage';
import FormErrorMessageForNode from './FormErrorMessageForNode';
import { withFormId } from '../FormIdContext';
import CustomContainer from '../CustomContainer';

import { STYLING_DEFAULT_ERROR_MESSAGE } from '../../constants/errorTypes';
import { getErrorMessages } from '../../../../entities/form/selectors';

const STYLE = 'style';
const ERRORS = 'errors';

const Container = styled(CustomContainer)`
    margin-top: ${containerPaddingM};
`;

const FormErrorContainer = (props) => {
    const errorNodeIds = Object.entries(props.errors)
        .filter(([id, errors]) => errors)
        .map(([id]) => id);

    if (props.areDummyErrorsVisible) {
        return (
            <Container>
                <FormErrorMessageForNode errorType={STYLING_DEFAULT_ERROR_MESSAGE} />
            </Container>
        );
    }

    if (!errorNodeIds.length) {
        return null;
    }

    const apiError = errorNodeIds[0] === '0' ? props.errors[errorNodeIds[0]][0] : null;
    const defaultError = getGenericSubmissionErrorMessage(props.formErrorMessages);
    return (
        <Container>
            <FormErrorMessage errorType={apiError || defaultError} />
        </Container>
    );
};

FormErrorContainer.propTypes = {
    errors: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])),
    formErrorMessages: PropTypes.object.isRequired,
    areDummyErrorsVisible: PropTypes.bool.isRequired,
};

FormErrorContainer.defaultProps = {
    errors: {},
};

const mapStateToProps = (state, props) => {
    const activeSidebarTab = getActiveSidebarTab(state);
    const openStylingSection = getOpenStylingSection(state);
    const areDummyErrorsVisible = activeSidebarTab === STYLE && openStylingSection === ERRORS;

    const formErrorMessages = getErrorMessages(state, props.formId);

    return {
        areDummyErrorsVisible,
        errors: getFormErrors(state),
        formErrorMessages,
    };
};

export default compose(withFormId, connect(mapStateToProps, {}))(FormErrorContainer);
